"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DcanSession = exports.AdapterModes = exports.DCAN_BAUD_RATE = exports.DCAN_CONCEPT = exports.segmentIsoTpPayload = void 0;
exports.switchToCanMode = switchToCanMode;
const constants_1 = require("./constants");
const telegram_1 = require("./telegram");
var ediabasx_protocol_uds_1 = require("@emdzej/ediabasx-protocol-uds");
Object.defineProperty(exports, "segmentIsoTpPayload", { enumerable: true, get: function () { return ediabasx_protocol_uds_1.segmentIsoTpPayload; } });
exports.DCAN_CONCEPT = 0x0110;
exports.DCAN_BAUD_RATE = 500000;
exports.AdapterModes = {
    Uart: "uart",
    Kwp: "kwp",
    Can: "can"
};
async function switchToCanMode(transport, baudRate = exports.DCAN_BAUD_RATE) {
    await transport.configure({
        baudRate,
        dataBits: 8,
        parity: "none",
        stopBits: 1
    });
    await transport.setDtr(true);
    await transport.setRts(true);
}
class DcanSession {
    adapterType;
    adapterVersion;
    canTxId;
    canRxId;
    canFlags;
    baudRate;
    protocol;
    constructor(options) {
        this.adapterType = options.adapterType;
        this.adapterVersion = options.adapterVersion;
        this.canTxId = options.canTxId;
        this.canRxId = options.canRxId;
        this.canFlags = options.canFlags ?? constants_1.CanFlags.Empty;
        this.baudRate = options.baudRate ?? exports.DCAN_BAUD_RATE;
        this.protocol = options.protocol ?? constants_1.Protocols.IsoTp;
    }
    buildTelegram(payload) {
        const telegram = (0, telegram_1.createCanTelegram)(payload, payload.length, {
            adapterType: this.adapterType,
            adapterVersion: this.adapterVersion,
            currentBaudRate: this.baudRate,
            currentProtocol: this.protocol,
            canTxId: this.canTxId,
            canRxId: this.canRxId,
            canFlags: this.canFlags
        });
        if (!telegram) {
            throw new Error("Unable to create CAN telegram");
        }
        return telegram;
    }
    async sendRequest(transport, payload) {
        const telegram = this.buildTelegram(payload);
        await transport.write(telegram);
    }
}
exports.DcanSession = DcanSession;
//# sourceMappingURL=dcan.js.map